// extracted by mini-css-extract-plugin
module.exports = {"overAll":"nondsskill_overAll__--huM","errorMessage":"nondsskill_errorMessage__HFbra"};